import styled from 'styled-components';
import { COLOR_WHITE } from '../../assets/styles/colors';
import { BP_TABLET_MAX } from '../../assets/styles/breakpoints';

export default styled.table`
  width: 100%;
  thead {
    border-collapse: separate;
    tr {
      th {
        position: relative;
        font-weight: normal;
        text-align: center;
        padding-bottom: 8px;
        padding-top: 6px;

        &:before {
          z-index: 0;
          position: absolute;
          top: 0px;
          left: 0px;
          content: '';
          width: 100%;
          height: 100%;
          border: 2px solid white;
          border-right: none;
          border-left: none;
        }

        &:first-child {
          &:before {
            border-top-left-radius: 20px;
            border-left: 2px solid white;
          }
        }
        &:last-child {
          padding-right: 32px;
          &:before {
            border-top-right-radius: 20px;
            border-right: 2px solid white;
          }
        }
      }
      td {
        text-align: center;
      }
    }
  }
  tbody {
    box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
    border-radius: 12px;
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    tbody {
      box-shadow: none;
      border-radius: 0px;
    }
  }
`;

export const AdditionalTopSC = styled.div`
  padding-bottom: 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;

  .small-btn {
    padding: 3px 16px 2px 16px;
    border-radius: 8px;
  }
`;

export const PaginationWrapSC = styled.div`
  background: ${COLOR_WHITE};
  box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  height: 50px;
  padding: 0 32px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;

  @media (max-width: ${BP_TABLET_MAX}px) {
    padding: 0 16px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
`;

export const EmptySC = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 200px;
  background: white;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
`;

export const FilterRowSC = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;

  margin-bottom: 8px;

  @media (max-width: ${BP_TABLET_MAX}px) {
    width: 100%;
  }
`;
